import React from 'react';
import { SCM_DATA_DISCLAIMER_SHORT } from '../../../lib/scmDisclaimer';

export const ScmDataDisclaimer: React.FC<{ compact?: boolean }> = ({ compact }) => (
  <p
    className="type-body text-text-muted border border-border bg-muted/20 px-2 py-1.5"
    data-testid="scm-data-disclaimer"
  >
    {compact ? SCM_DATA_DISCLAIMER_SHORT : (
      <>
        <span className="font-semibold text-text-secondary">Data caveat: </span>
        Directory pricing, lead times, and availability are indicative and may be outdated.
        Confirm all commercial terms directly with the supplier before procurement decisions.
      </>
    )}
  </p>
);
